import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import {
  type PortalTabbedNavigationTab,
  TabbedNavigationGroup,
} from '../../../../../../../../../../../../../components/router/router-tabbed-navigation';
import { CostBasisTaxLotsTable } from '../../../../../../../../../../../../../features/cost-basis/tax-lot/cost-basis-tax-lots-table';
import { AccountPortfolioAssetBalanceHeader } from '../../../../../../../../../../../../../features/registration/account/account-portfolio-asset-balance-header';

export const Route = createFileRoute(
  '/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/tax-lot/',
)({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.RegistrationAccountPortfolioAssetBalance,
      label: 'Tax Lots',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.RegistrationAccountPortfolioAssetBalance>,
  component: AccountAssetTaxLotList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  const { accountId, assetId } = Route.useParams();
  return <AccountPortfolioAssetBalanceHeader accountId={accountId} assetId={assetId} filter={filter} />;
}

function AccountAssetTaxLotList() {
  const { accountId, assetId } = Route.useParams();

  return (
    <PageLayout.Section noBorder>
      <CostBasisTaxLotsTable accountId={accountId} assetId={assetId} HeaderActions={TableHeader} />
    </PageLayout.Section>
  );
}
